import styled from 'styled-components';

interface ISlide {
  show: boolean;
  startAnim: boolean;
  notShow?: boolean;
}

export const Container = styled.div<ISlide>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #fff 0%, #eee 100%), #dfdfdf;

  /* Fade do container inteiro */
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.6s ease-in-out;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 980px;
    height: 551.25px;
  }
`;
